iScreenWizard.controller('C2PCompetentieprofielController', function ($scope, $state, $mdDialog, $filter, Ajax, Dictionary, ErrorHandler, userService, Competentieprofiel, Competentiegroep, Competentie, Opleidingsgroep, c2pService) {

    var pagesize = 20;

    $scope.userService = userService;
    $scope.c2p = c2pService.model;

    $scope.searchTerm = '';

    $scope.competentieprofielen = [];
    $scope.competentieprofielenPage = 1;
    $scope.competentieprofielenMorePages = true;
    $scope.alreadyLoading = false;


    $scope.focusedCompetentieprofiel = {};

    $scope.opleidingsgroepen = [];

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    var refresh = function() {
        c2pService.model.competentieprofielen = [];
        $scope.competentieprofielenPage = 1;
        $scope.competentieprofielen = [];
        $scope.loadCompetentieprofielen();

        Opleidingsgroep.all().then(function(opleidinsgroepen) {
            $scope.opleidingsgroepen = opleidinsgroepen;
        });
    };
    $scope.refresh = refresh;

    $scope.loadMoreCompetentieprofielen = function() {
        $scope.competentieprofielenPage = $scope.competentieprofielenPage+1;
        $scope.loadCompetentieprofielen();
    };

    $scope.loadCompetentieprofielen = function() {
        if (!$scope.alreadyLoading) {
            $scope.alreadyLoading = true;
            params = {
                pagesize: pagesize,
                page: $scope.competentieprofielenPage,
                orderby: 'titel',
                matching_testafname_id: c2pService.model.testafname.id
            };
            if ($scope.searchTerm.length > 0) {
                params.titel = $scope.searchTerm;
            }
            Competentieprofiel.all(params).then(function (competentieprofielen) {
                $scope.alreadyLoading = false;
                angular.forEach(competentieprofielen, function (competentieprofiel) {

                    competentieprofiel.index = -1;
                    angular.forEach($scope.c2p.competentieprofielen, function (anderCompetentieprofiel, index) {
                        if (anderCompetentieprofiel.id == competentieprofiel.id) {
                            competentieprofiel.index = index;
                        }
                    });

                    $scope.competentieprofielen.push(competentieprofiel);
                });
                if (competentieprofielen.length < pagesize) {
                    $scope.competentieprofielenMorePages = false;
                }
            });
        }
    };

    $scope.searchCompetentieprofiel = function() {
        $scope.competentieprofielenPage = 1;
        $scope.competentieprofielen = [];
        $scope.competentieprofielenMorePages = true;
        $scope.loadCompetentieprofielen();
    };

    $scope.addCompetentieprofiel = function(competentieprofiel) {
        var index = competentieprofiel.index;
        if (index < 0) {
            competentieprofiel.index = $scope.c2p.competentieprofielen.length;
            $scope.c2p.competentieprofielen.push(competentieprofiel);
        }
    };

    $scope.deleteCompetentieprofiel = function(competentieprofiel) {
        var index = competentieprofiel.index;
        $scope.c2p.competentieprofielen.splice(index, 1);
        competentieprofiel.index = -1;
        angular.forEach($scope.c2p.competentieprofielen, function (competentieprofiel, index) {
            competentieprofiel.index = index;
        });
    };

    $scope.next = function() {
        if (c2pService.model.competentieprofielen.length > 0) {
            $state.go('matching/c2p/ideaalscores');
        }
    };

});